import { render, staticRenderFns } from "./AddProductDetails.vue?vue&type=template&id=87d232a0"
var script = {}
import style0 from "./AddProductDetails.vue?vue&type=style&index=0&id=87d232a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports